angular.module('unergie.main')
.controller('cmsCtrl', ($scope, $state, ModalService, AlertManager, CMS, NgTableParams, ReferencesService, DataAccessMedias, Tokens, EnvUtils, ErrorCatcher) => {
    const refresh = function () {
        $scope.refreshing = true
        return CMS.searchContents().$promise.then((data) => {
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 10,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data }) }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.EnvUtils = EnvUtils

    $scope.refresh = refresh
    refresh()

    $scope.delete = (content) => {
        content.deleting = true
        return CMS.deleteContent({ id: content._id }).$promise
        .then(() => {
            AlertManager.success('Contenu supprimé')
            refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            content.deleting = false
        })
    }

    $scope.refreshContent = (content) => {
        content.refreshing = true
        return CMS.fetchContent({ id: content._id }).$promise
        .then((result) => {
            _.assign(content, result)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            content.refreshing = false
        })
    }

    $scope.toggleExpand = (content) => {
        if (!content.refreshing) {
            content.expanded = !content.expanded
            if (!content.fetched) {
                $scope.refreshContent(content)
            }
        }
    }

    const resetNewBlockPayload = () => {
        $scope.newBlockPayload = {
            page: '',
            contentId: '',
            description: '',
        }
    }

    resetNewBlockPayload()

    $scope.newBlockFields = {
        page: {
            label: 'Page',
            type: 'text',
            required: true,
        },
        contentId: {
            label: 'Id contenu',
            type: 'text',
            required: true,
        },
        description: {
            label: 'Description',
            type: 'text',
        },
    }

    $scope.new = () => {
        $scope.creating = true
        return CMS.addContent($scope.newBlockPayload).$promise
        .then(() => {
            AlertManager.success('Contenu créé')
            resetNewBlockPayload()
            refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.edit = (content, versionId) => {
        ModalService.openModal({ type: 'cmsModal', size: 'xlg' }, { contentId: content._id, versionId }, refresh)
    }
})
